'use client';
import { Xmark } from 'iconoir-react';
import React, { useEffect, useState } from 'react';
import { OrthDownloadApp } from '~/icons';
import { useThemeStore } from '../stores/useThemeStore';
import { useTranslations } from 'next-intl';
import { Button } from '@AydiTeam1/aydi-ui';
import OrthLogo from '@/modules/shared/components/AppSideNav/OrthLogo';
import { useSearchParams, usePathname } from 'next/navigation';
import { detectMobilePlatform } from '../utils';

function DownloadAppModal() {
  const t = useTranslations('default');
  const { mode } = useThemeStore();
  const searchParams = useSearchParams();

  const pathname = usePathname();
  const [showModal, setShowModal] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [platform, setPlatform] = useState<'ios' | 'android' | null>(null);

  const isSubscribed = searchParams.get('isSubscribed') === 'true';
  const isTeamSubscriptionRoute = pathname?.includes('/team-subscription') || pathname?.toLowerCase().includes('/mobilecallback');
  const isInvitationPath = pathname?.includes('/invitations/accept');
  const openedChatThread = searchParams.get('threadId');

  const redirectedToPayment = searchParams.get('redirected-to-payment') === 'true' ||
    (typeof window !== 'undefined' && sessionStorage.getItem('redirected-to-payment') === 'true');

  const IOSLink = 'https://apps.apple.com/us/app/orth/id6754557886';
  const AndroidLink =
    'https://play.google.com/store/apps/details?id=com.aydi.orth.app&pli=1';

  useEffect(() => {
    const isCloseMobileModal = sessionStorage.getItem('closeMobileModal');
    if (isCloseMobileModal === null) {
      sessionStorage.setItem('closeMobileModal', 'false');
    }
    const userAgent = navigator?.userAgent || '';
    const isMobile = /Mobile|Android|iPhone|iPad/i.test(userAgent);
    const detectedPlatform = detectMobilePlatform()
    setIsMobileDevice(isMobile);
    setPlatform(detectedPlatform);
  }, []);

  useEffect(() => {
    if (isMobileDevice &&
       !isSubscribed &&
       !isTeamSubscriptionRoute &&
       !redirectedToPayment &&
       !openedChatThread &&
       !isInvitationPath) {
      setShowModal(sessionStorage.getItem('closeMobileModal') === 'false');
    } else {
      setShowModal(false);
    }
  }, [isMobileDevice, isSubscribed, isTeamSubscriptionRoute, redirectedToPayment, openedChatThread]);

  const handleClose = () => {
    setShowModal(false);
    sessionStorage.setItem('closeMobileModal', 'true');
  };

  const handleDownload = () => {
    window.open(platform === 'ios' ? IOSLink : AndroidLink, '_blank');
  };


  return showModal && !isInvitationPath ? (
    <div className='fixed z-[60] top-0 left-0 w-screen h-screen bg-background px-32 py-16'>
      <div className='w-full relative flex justify-center items-center'>
        <OrthLogo />
        <div className='absolute top-1/2 -end-16 -translate-y-1/2 flex'>
          <Xmark
            onClick={handleClose}
            className='cursor-pointer text-on-background text-18'
          />
        </div>
      </div>
      <div className='h-full flex flex-col gap-32 items-center mt-44'>
        <OrthDownloadApp
          shadowColor='white'
          fillColor={mode === 'Light' ? '#1D1D1D' : 'white'}
          strokeColor='#A6A7AC'
        />
        <div className='w-full px-32 mt-32 flex flex-col gap-2 text-center mb-32'>
          <h3 className='text-on-background text-24 font-semibold'>
            {t('agronomist-in-pocket')}
          </h3>
          <p className='text-on-surface-variant text-16'>
            {t('agronomist-in-pocket-description')}
          </p>
        </div>
        <Button
          size='medium'
          className='bg-on-background w-full'
          onClick={handleDownload}
        >
          {t('download-app')}
        </Button>
      </div>
    </div>
  ) : (
    <></>
  );
}

export default DownloadAppModal;
